export default function authHeader() {
  const obj = JSON.parse(localStorage.getItem("authUser"))

  if (obj && obj.refresh) {
    return obj.refresh
  } else {
    return null
  }
}
